import {selectors} from '@packages/systems/spring';
import {emotionStyled} from '@packages/utilities/styled';

export const MirrorWrapper = emotionStyled('div')({
  border: '1px solid $uiInputBorderColor',
  borderRadius: '$2',
  [`&${selectors.hovered}`]: {
    borderColor: '$uiInputBorderColorHover',
  },
  [`&${selectors.nonErrorFocused}`]: {
    borderColor: '$blueBorder',
    outline: 'none',
  },
  overflow: 'hidden', // Prevent scrollbar from overlapping the border
  resize: 'none', // Fixed height — no draggable resize handle
});
